import {
  CommonDialogLayout,
  createPortableDialog,
  Dialog,
  PaymentDialogLayoutProps,
  usePortableDialog,
} from '@wwe-portal/ui/components/dialog';

export const CommonDialog = createPortableDialog(
  (props: Omit<PaymentDialogLayoutProps, 'onClose'>) => {
    const modal = usePortableDialog();
    return (
      <Dialog
        open={modal.visible}
        onOpenChange={(value) => {
          if (!value) {
            modal.remove();
          }
        }}
      >
        <CommonDialogLayout {...props} onClose={modal.remove} />
      </Dialog>
    );
  }
);
